module.exports = __webpack_public_path__ + "img/visa.107ef98.svg";